module.exports = __webpack_public_path__ + "491acabd936d603c60b55c3ebf20ce63.png";